<template>
	<div class="container" style="overflow: hidden;">
		<van-sticky>
		<div class="main_box">
			<!--块1-->
			<div class="nav_box">
				<div
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
					class="logo_box"
					@click="goIndex"
				>
					<img src="../../assets/img_public/logo.webp" />
					<div>宝&nbsp;&nbsp;&nbsp;&nbsp;瑞&nbsp;&nbsp;&nbsp;&nbsp;源&nbsp;&nbsp;&nbsp;&nbsp;生&nbsp;&nbsp;&nbsp;&nbsp;物</div>
				</div>
				<div
					data-aos="fade-left"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
					class="left"
				>
					<div v-if="navList.length > 0" class="list_box">
						<div
							v-for="(value, index) in navList"
							:key="index"
							class="list_el"
							:class="navActived == value.title ? 'actived' : ''"
							@mouseover="navMouseover(value)"
							@click="oneNavClick(value)"
						>{{ value.title }}</div>
					</div>
				</div>
				<div
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
					class="right"
				>
					<img class="phone" src="../../assets/img_public/nav/icon_phone.webp" />
					<img class="search" src="../../assets/img_public/nav/icon_search.webp" @click="searchClick" />
					<div class="check_box">
						<span class="cn">中</span> / <span class="en" @click="checkEN">EN</span>
					</div>
				</div>
			</div>
			<!--块1-->
		</div>
		</van-sticky>
		<!--导航-->
		<div v-if="navShow" class="nav_show_box"
			data-aos="fade-in"
			data-aos-duration="400"
			data-aos-delay="100"
			data-aos-offset="0"
			data-aos-once="true"
		>
			<!--非产品-->
			<div
				v-if="!isProducts"
				class="nav_other"
				@mouseleave="navChildleave"
			>
				<div
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="	0"
					data-aos-offset="0"
					data-aos-once="true"
					v-for="(value, index) in otherList"
					:key="index"
					@click="oneNavClick(value, true)"
				>{{ value.title }}</div>
			</div>
			<!--非产品-->
			<!--产品-->
			<div v-if="isProducts"
				class="nav_products"
				@mouseleave="navChildleave"
			>
				<div
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="	0"
					data-aos-offset="0"
					data-aos-once="true"
					class="nav_products_top"
				>
					<div v-if="productList.length > 0" class="nav_products_top_main">
						<div
							v-for="(value, index) in productList"
							:key="index"
							class="cate_el"
							:class="productListId == value.id ? 'actived' : ''"
							@click="checkProductList(value)"
						>
							<img :src="productListId == value.id ? webUrl + value.icon_active : webUrl + value.icon" />
							<div class="tit">{{ value.title }}</div>
						</div>
					</div>
				</div>
				<div
					v-if="productLists.length > 0"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="	0"
					data-aos-offset="0"
					data-aos-once="true"
					class="nav_products_bot"
				>
					<div class="list_box">
						<waterfall
							:width="0"
							:gutterWidth="0"
							:col="3"
							:data="productLists"
						>
							<div v-for="(value1, index1) in productLists" :key="index1" class="list_el">
								<div class="tit" @click="goProductList(value1)">{{ value1.title }}</div>
								<template v-if="value1.children.length > 0">
									<div v-for="(value2, index2) in value1.children" :key="index2" class="txt" @click="goProductInfo(value2)">{{ value2.name }}</div>
								</template>
							</div>
						</waterfall>
						
					</div>
				</div>
			</div>
			<!--产品-->
		</div>
		<!--搜索-->
		<div v-if="searchShow" class="search_box"
			data-aos="fade-in"
			data-aos-duration="400"
			data-aos-delay="100"
			data-aos-offset="0"
			data-aos-once="true"
		>
			<div class="search_main">
				<div class="search_el">
					<van-icon name="close" size="30px" color="#C8000A" class="icon_close" @click="searchShow = false" />
					<input v-model="searchVal" ref="searchDom" :placeholder="$t('nav.text1')" @keyup.enter="goSearch" />
					<van-icon name="down" size="22px" color="#C8000A" class="icon_right" @click="goSearch" />
				</div>
			</div>
		</div>
		<!--搜索-->
	</div>
</template>

<script>
import { UPURL } from '@/util/util';
import $ from 'jquery'
export default {
	props: ['pageName'],
	components: {
		//
	},
	data() {
		return {
			navList: [],
			navActived: this.pageName,
			searchShow: false,  //搜索弹框
			searchVal: '',  //搜索值
			navShow: false,  //导航弹框
			otherList: [],  //二级导航非产品数据
			isProducts: false,  //二级导航是否为产品
			productList: [],
			productLists: [],
			productListId: null,
			productListType: 1,
			webUrl: UPURL,
			lang: sessionStorage.getItem('lang')
		}
	},
	created() {
		let that = this;
		if(sessionStorage.getItem('navList')) {
			that.navList = JSON.parse(sessionStorage.getItem('navList'));
			that.productList = that.navList[1].children.cate_list;
			that.productLists = that.productList[0].children;
			that.productListId = that.productList[0].id;
		}
	},
	mounted() {
		let that = this;
	},
	watch: {
		//
	},
	methods: {
		//切换产品分类
		checkProductList(value) {
			let that = this;
			that.productLists = [];
			that.productListId = value.id;
			if(value.title == '解决方案') {
				that.productListType = 2;
			}else {
				that.productListType = 1;
			}
			setTimeout(() => {
				that.productLists = value.children;
			}, 100);
		},
		//切换en
		checkEN() {
			sessionStorage.clear();
			localStorage.clear();
			window.location.replace("https://abiores.com");
			// window.location.href = '';
		},
		//跳转产品列表
		goProductList(value) {
			let that = this;
			if(that.productListType == 2) {
				if(that.$route.name === 'Product') {
					that.$router.push({ path: '/product.html', query: { scenarios_ids: value.id } });
					window.location.reload();
				}else {
					that.$router.push({ path: '/product.html', query: { scenarios_ids: value.id } });
				}
			}else {
				if(that.$route.name === 'Product') {
					that.$router.push({ path: '/product.html', query: { cate_ids: value.id } });
					window.location.reload();
				}else {
					that.$router.push({ path: '/product.html', query: { cate_ids: value.id } });
				}
			}
		},
		//跳转产品详情
		goProductInfo(value) {
			let that = this;
			let routeData = that.$router.resolve({name: "ProductInfo", params: { productInfoId: value.id + '.html' } });
			// window.open(routeData.href, '_blank');
			window.location.href = routeData.href;
		},
		//跳转产品列表
		goProduct() {
			let that = this;
			if (this.$route.path != '/product.html') {
				this.$router.push({ path: '/product.html' });
			}else {
				window.location.reload();
			}
		},
		//一级导航点击
		oneNavClick(value, value2) {
			let that = this;
			if(that.$route.path != value.url) {
				if(value2) {
					if(that.$route.name === value.route) {
						that.$router.push({ path: value.url, });
						window.location.reload();
					}else {
						if(that.$route.path != value.url) {
							that.$router.push({ path: value.url, });
						}
					}
				}else {
					that.$router.push({ path: value.url });
				}
			}else {
				window.location.reload();
			}
		},
		//导航滑入
		navMouseover(value) {
			let that = this;
			if(value.title != '首页' && value.title != '联系我们') {
				if(value.title == '产品中心') {
					that.navShow = true;
					that.isProducts = true;
				}else {
					that.otherList = value.children;
					that.navShow = true;
					that.isProducts = false;
				}
			}else {
				that.navShow = false;
				that.isProducts = false;
			}
		},
		//子导航滑出
		navChildleave() {
			let that = this;
			that.navChildShow = false;
			that.navShow = false;
			that.isProducts = false;
		},
		//点击搜索
		searchClick() {
			let that = this;
			that.searchShow = true;
			setTimeout(() => {
				that.$refs.searchDom.focus();
			}, 400);
		},
		//点击搜索确定
		goSearch() {
			let that = this;
			if(that.searchVal) {
				that.$router.push({ path: '/search.html', query: { search: that.searchVal, } });
			}else {
				that.$toast('请先输入搜索内容');
			}
		},
		//点击首页
		goIndex() {
			if (this.$route.path != '/') {
				this.$router.push({
					path: '/'
				});
			} else {
				window.location.reload();
			}
		},
	}
}
</script>

<style lang="less" scoped>
.nav_show_box{
	color: #333333;
	width: 100%;
	height: calc(100vh - 90px);
	position: fixed;
	top: 90px;
	left: 0;
	background-color: rgba(0,0,0,.7);
	z-index: 999;
	.nav_products{
		height: 80vh;
		background-color: #ffffff;
		overflow: auto;
		border-top: 1px solid #C8000A;
		.nav_products_bot{
			width: 1200px;
			margin: 0 auto;
			.list_box{
				// display: flex;
				padding: 40px 0;
				.list_el{
					// flex: 1;
					// width: 50%;
					padding: 0 40px 25px 40px;
					.txt{
						margin: 10px 0;
						font-size: 16px;
						color: #000000;
						// overflow: hidden;
						// text-overflow: ellipsis;
						// display: -webkit-box;
						// -webkit-line-clamp: 1;
						// -webkit-box-orient: vertical;
						cursor: pointer;
						user-select: none;
					}
					.tit{
						margin-bottom: 15px;
						font-size: 18px;
						color: #666666;
						// overflow: hidden;
						// text-overflow: ellipsis;
						// display: -webkit-box;
						// -webkit-line-clamp: 2;
						// -webkit-box-orient: vertical;
						cursor: pointer;
						user-select: none;
					}
				}
			}
		}
		.nav_products_top{
			width: 100%;
			background-color: #EEEEEE;
			.nav_products_top_main{
				width: 1200px;
				margin: 0 auto;
				text-align: center;
				.cate_el{
					display: inline-block;
					padding: 40px 60px 30px 60px;
					cursor: pointer;
					user-select: none;
					.tit{
						padding-top: 10px;
						font-size: 16px;
						color: #333333;
					}
					img{
						width: 80px;
					}
				}
				.cate_el.actived{
					background-color: #ffffff;
				}
			}
		}
	}
	.nav_other{
		padding: 40px 0 44px 0;
		background-color: #ffffff;
		border-top: 1px solid #C8000A;
		text-align: center;
		div{
			display: inline-block;
			margin: 0 30px;
			font-size: 18px;
			cursor: pointer;
		}
		div:hover{
			color: #C8000A;
		}
	}
}
.search_box{
	color: #333333;
	width: 100%;
	height: calc(100vh - 90px);
	position: fixed;
	top: 90px;
	left: 0;
	background-color: rgba(0,0,0,.7);
	z-index: 999;
	.search_main{
		padding: 68px 0 80px 0;
		background-color: #F7F6F9;
		.search_el{
			width: 1112px;
			margin: 0 auto;
			position: relative;
			.icon_close{
				position: absolute;
				right: -100px;
				top: -35px;
				cursor: pointer;
			}
			.icon_left{
				position: absolute;
				top: 16px;
			}
			.icon_right{
				position: absolute;
				top: 16px;
				right: 0;
				transform: rotate(-90deg);
				cursor: pointer;
			}
			input{
				width: 100%;
				height: 60px;
				line-height: 60px;
				font-size: 20px;
				border: none;
				border-bottom: 1px solid #C8000A;
				color: #C8000A;
				padding: 0 38px;
				background-color: transparent;
				text-align: center;
			}
		}
	}
}
.main_box {
	color: #333333;
	height: 90px;
	box-shadow: 0px 0px 20px 1px rgba(0,0,0,0.05);
	background-color: #ffffff;
	.nav_box{
		width: 1200px;
		height: 100%;
		margin: 0 auto;
		display: flex;
		align-items: center;
		.right{
			width: auto;
			.check_box{
				display: inline-block;
				position: relative;
				top: 4px;
				cursor: pointer;
				.en{
					font-size: 17px;
				}
				.cn{
					color: #C8000A;
				}
			}
			.search{
				width: 36px;
				margin: 0 20px 0 30px;
				cursor: pointer;
			}
			.phone{
				width: 214px;
			}
		}
		.left{
			flex: 1;
			.list_box{
				padding-left: 55px;
				.list_el:hover{
					color: #C8000A;
				}
				.list_el.actived{
					background-color: #C8000A;
					color: #ffffff;
					border-radius: 6px;
				}
				.list_el{
					display: inline-block;
					margin: 0 8px;
					padding: 5px 14px;
					font-size: 16px;
					color: #333333;
					cursor: pointer;
				}
			}
		}
		.logo_box{
			width: auto;
			cursor: pointer;
			position: relative;
			top: 4px;
			div{
				padding-top: 0px;
				text-align: center;
				font-size: 18px;
				color: #C8000A;
			}
			img{
				width: 148px;
				position: relative;
				top: -5px;
			}
		}
	}
}
</style>